import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toggle-switch",class:{
		[`toggle-switch-${_vm.isOn ? 'on' : 'off'}-${_vm.disabled ? 'disabled' : 'enabled'}`]: true,
	},on:{"click":_vm.toggle}},[(_vm.isOn && !_vm.disabled)?_c('complex-background-x-s'):_vm._e(),_c('div',{staticClass:"toggle-knob",class:{ 'on-knob': _vm.isOn }},[(_vm.isOn)?_c(VIcon,{attrs:{"small":"","color":"var(--dark-purple-900)"}},[_vm._v(" mdi-check ")]):_c(VIcon,{attrs:{"small":"","color":"var(--grey-900)"}},[_vm._v(" mdi-close ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }